import React, { useState, useEffect, useContext } from 'react';
import { createBulkQuotation, getCustomers, getTax, getUnits, getManufacturers, createProduct, getproductvalue, getInvoiceNumber } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import ProductForm from "../Product/Form";
import { WarehouseContext } from '../../../Utility/UserContext';
import '../Purchase/dropdown.css';
import { InputField, NewCommonCardUi, SelectField, SelectOption } from '../../Common/CommonCard';
import SupplierForm from '../Suppliers/form';
import { useNavigate } from 'react-router-dom';
import CustomerAddModal from '../../Common/CustomerAddModal';
import { warehouse_id } from "../../../Utility/function";
import { useCallback } from 'react';
const AddQuotation = () => {
    const navigate = useNavigate()
    const [taxes, setTax] = useState([]);
    const [Units, setUnits] = useState([]);
    const [supplierdata, setsupplierData] = useState()
    const [Manufacturers, setManufacturers] = useState([]);
    const [discount, setDiscount] = useState(0);
    const [vat, setVat] = useState(0);
    const [freightCharges, setFreightCharges] = useState(0);
    const [otherCharges, setOtherCharges] = useState(0);
    const [roundoff, setRoundOff] = useState(0);
    const [products, setProducts] = useState([]); // To store all products
    const [filteredProducts, setFilteredProducts] = useState([]); // To store filtered products
    const [filteredSuppliers, setFilteredSuppliers] = useState([]); // To store filtered products
    const [supplier, setSupplier] = useState([]);
    const [SupplierId, setSupplierId] = useState(0);
    const { selectedWarehouse } = useContext(WarehouseContext);
    const [unqui, setunqui] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productdata, setproductData] = useState()
    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
    const [AuthUser, setAuthUser] = useState(UserItem);

    const [previousDue, setPreviousDue] = useState(0);
    useEffect(() => {
        // setunqui(generateRandomCode());
        fetchSuppliers();
        fetchManufacturers();
        fetchTax();
        fetchUnit();
        fetchInvoiceNumber();
    }, []);

    const fetchInvoiceNumber = async () => {
        try {
            const response = await getInvoiceNumber(2)
            if (response.data && response.data.invoice_no) {
                setunqui(response.data.invoice_no);
                setformData((pre) => ({
                    ...pre,
                    ...{
                      request_no: response.data.request_no,
                      finance_code: response.data.finance_code,
          
                    },
                  }));
                
            }
        } catch (error) {
            console.error('Error fetching Customers data:', error);

        }
    };

    const fetchUnit = async () => {
        try {
            const response = await getUnits()
            if (response.data && response.data.data) {
                setUnits(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching Customers data:', error);
        }
    }

    const fetchTax = async () => {
        try {
            const response = await getTax();
            if (response.data && response.data.data) {
                setTax(response.data.data);
            } else {
                toast.error('No Tax found.');
            }
        } catch (error) {
            console.error('Error fetching Tax:', error);
            toast.error('Error fetching Tax');
        }
    };

    useEffect(() => {
        if (!selectedWarehouse?.id) {
            toast.warning('Select a Warehouse before Entry');
        }
        fetchProducts(selectedWarehouse?.id);
    }, [selectedWarehouse]);

    const fetchSuppliers = async () => {
        try {
            const response = await getCustomers();
            if (response.data && response.data.data) {
                setSupplier(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching suppliers data:", error);
        }
    };

    const fetchManufacturers = async () => {
        try {
            const response = await getManufacturers(1);
            if (response.data && response.data.data) {
                setManufacturers(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching Customers data:', error);
        }
    };

    const fetchProducts = useCallback(async (ware_id = selectedWarehouse?.id) => {
        try {
            const response = await getproductvalue(ware_id,true);
            if (response.data && response.data.data) {
                setProducts(response.data.data)
                setFilteredProducts(response.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    },[])


    const [inputValue, setInputValue] = useState("");
    const [SupplierValue, setSupplierValue] = useState("");
    const [rows, setRows] = useState([]);

    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
        setRows(updatedRows);
    };

    const handleAddRow = async() => 
    {
        showLoader();
        const requiredFields = ['product_id', 'qty'];
        const missingFields = requiredFields.filter(field => !formData[field]);
        let ProductD =productdata
        if (missingFields.length > 0) {
            if(missingFields.length == 1 && missingFields[0] == "product_id"){
             const confirmed = window.confirm("The entered product is not in the product list. Are you sure you want to add it?");
             if (!confirmed) return;
            const payload ={
                product: {
                 product_name: inputValue,
                 barcode: "",
                 cat_id: "",
                 subcat_id: "",
                 supplier_id: "",
                 descriptions: "",
                 warehouse_id: selectedWarehouse?.id,
                 shop_id: (shopItem?.shop_id || "0")+"-Pending",
                 created_by: UserItem?.user_id || "0",
                 status: "1",
               
               },
               product_quantity:{
                product_id: "",
                product_qty_id: "",
                supplier_id: "",
                manufacturer_id: "",
                purchase_unit: "",
                sales_unit: "",
                qty: formData.qty,
                purchase_price: formData.purchase_price,
                sales_price: formData.sales_price,
                box_sales_cost: formData.box_sales_cost || "0",
                manufacturing_date: formData.manufactured_date,
                descriptions: formData.remarks,
                expiry_date: formData.expiry_date,
                status: 1,
                remaining: formData.qty,
                user_id: UserItem?.user_id || "0",
                brand_id: "1",
                in_or_out: "0",
                shop_id: (shopItem?.shop_id || "0")+"-Pending",
                created_by: UserItem?.user_id || "0",
                warehouse_id:(selectedWarehouse?.id)+"-Pending",
                delivery_time:"",
                company_name:formData.company_name,
                contact_person:formData.contact_person,
              }
            }
               const res = await createProduct(payload);
               setproductData(res?.data?.product)
               ProductD =res?.data?.product
            }else{
                hideLoader();
                toast.error(`Please fill out the following fields: ${missingFields.join(', ')}`);
                return;
            }
        }
        if (formData.qty <= 0) {
            hideLoader();
            toast.error(`Qty must be greater then 0`);
            return;
        }
        const isProductDuplicate = rows.some(row => row.product_id === formData.product_id);
        if (isProductDuplicate) {
            hideLoader();
            toast.error("This product is already added.");
            return;
        }
        const newRow = {
            id: rows.length + 1,
            product_id: formData.product_id || ProductD?.id,
            supplier_id: formData.supplier_id,
            manufacturer_id: formData.manufacturer_id,
            qty: formData.qty,
            warehouse_id: selectedWarehouse?.id,
            product_name: ProductD.product_name,
            item_code:formData.remarks,
            purchase_price: formData.purchase_price,
            total_amount: formData.total_amount,
            sales_price: formData.sales_price,
            manufactured_date: formData.manufactured_date,
            expiry_date: formData.expiry_date,
            storage_type: ProductD.storage_type,
            purchase_unit: formData.purchase_unit,
            box_sales_cost: formData.box_sales_cost,
            purchase_type: formData.purchase_type,
            delivery_time:formData.delivery_time,
            company_name:formData.company_name,
            contact_person:formData.contact_person,
        };
        setRows([...rows, newRow]);
        setformData({
            ...formData,
            remark: '',
            remarks: '',
            supplier_invoice_no: '',
            supplier_invoice_date: '',
            product_id: "",
            supplier_id: formData.supplier_id,
            purchase_price: '',
            qty: '',
            total_amount: '',
            sales_price: '',
            // manufactured_date: '',
            // expiry_date: '',
            manufacturer_id: "",
            box_sales_cost: "0",
            warehouse_id: selectedWarehouse?.id,
            purchase_type: "1",
            delivery_time:"",
            
        })
        setInputValue("");
        setproductData();
        hideLoader();
    };



    const [formData, setformData] = useState({
        warehouse_id: selectedWarehouse?.id,
        invoice_no: '',
        invoice_date: '',
        ref_1: '',
        ref_2: '',
        purchase_unit: '1',
        tax_type: '',
        remark: '',
        supplier_invoice_no: '',
        supplier_invoice_date: '',
        product_id: "",
        supplier_id: '',
        total_amount: '',
        qty: '',
        purchase_price: '0',
        sales_price: '0',
        manufactured_date: '',
        expiry_date: '',
        manufacturer_id: "",
        box_sales_cost: "0",
        purchase_type: "1",
        approval_status:"0",
        currency_type: "",
        remarks: "",
        delivery_time:"",
        payment_terms:"",
        warranty:"",
        discount:"",
        tax_number:"",
        category_type:"",
        finance_code:"",
        request_no:"",
        contact_person:"",
        company_name:"",
        sales_person:"",
        sales_contact:""
    })

    const handleProductChange = async (index, value) => {
        setInputValue(value);
        // if (value === "") {
        //     setFilteredProducts(products);
        // } else {
        //     const filtered = products.filter((product) =>
        //         product.product_name?.toLowerCase().includes(value?.toLowerCase())
        //     );
        //     setFilteredProducts(filtered);
        // }
        if (value === "") {
            setFilteredProducts(products.filter(product => product.status != 2));
          } else {
            const filtered = products.filter(product =>
              product.status != 2 && product.product_name?.toLowerCase().includes(value?.toLowerCase())
            );
            setFilteredProducts(filtered);
          }
          
        const selectedProduct = filteredProducts.find(product =>
            product.product_name?.toLowerCase() === value?.toLowerCase()
        );

        if (selectedProduct) {
            const updatedRows = rows.map((row, rowIndex) =>
                rowIndex === index ? { ...row, product_id: selectedProduct.product_id } : row
            );
            setRows(updatedRows);
            setFilteredProducts([]);
        }
    };

    const handleSupplierChange = (index, value) => {
        setSupplierValue(value);

        if (value === "") {
            setFilteredSuppliers(supplier.filter(item => item.status != 1));
        } else {
            const filtered = supplier.filter(supplier =>
                supplier.status != 1 && supplier.name?.toLowerCase().includes(value?.toLowerCase())
            );
            setFilteredSuppliers(filtered);
        }

        const selectedSuppliers = filteredSuppliers.find(supplier =>
            supplier.name?.toLowerCase() === value?.toLowerCase()
        );

        if (selectedSuppliers) {
            const updatedRows = rows.map((row, rowIndex) =>
                rowIndex === index ? { ...row, customer_id: selectedSuppliers.customer_id } : row
            );
            setRows(updatedRows);
            setFilteredSuppliers([]);
        }
    };

    const clearData = () => {
        setRows([
            {
                id: 1,
                product_id: "",
                manufacturer_id: "",
                brands_id: "",
                qty: "",
                supplier_id: "",
                warehouse_id: selectedWarehouse?.id,
            },
        ]);
        setSupplierId();
    };

    const HandleSubmit = async () => {
        showLoader()
        try {
            if (rows.length <= 0) {
                toast.error('Add item before Add Quotation order');
                hideLoader();
                return
            }

            if (!SupplierId) {
                toast.error('Required Customer');
                hideLoader();
                return
            }


            const saveObject = {
                user_id: AuthUser?.user_id,
                supplier_id: SupplierId,
                data: rows,
                po_id: unqui,
                sub_total: getTotal().sub_total,
                purchase_unit: formData.purchase_unit,
                // lpo_no: formData.lpo_no,
                discount: formData.discount,
                vat: vat,
                freight_charges: freightCharges,
                other_charges: otherCharges,
                previous_due: previousDue,
                total: getTotal().total,
                round_off: getTotal().roundOff,
                grand_total: getTotal().grandTotal,
                balance: getTotal().balance,
                shop_id: shopItem?.shop_id || "0",
                created_by: UserItem?.user_id || "0",
                payment_terms:formData.payment_terms,
                remarks:formData.remarks,
                tax_number:formData.tax_number,
                category_type:formData.category_type,
                currency_type:formData.currency_type,
                approval_status:formData.approval_status,
                finance_code: formData.finance_code,
                request_no: formData.request_no,
                expiry_date: formData.expiry_date,
                company_name:formData.company_name,
                contact_person:formData.contact_person,
                sales_person:formData.sales_person,
                sales_contact:formData.sales_contact
            };

            const Data = await createBulkQuotation(saveObject);
            if (Data?.data.status === 'success') {
                toast.success('Quotation Order added successfully');
                hideLoader()
                // window.location.href = "/Quotation_list";
                navigate(-1);
            }
        } catch (error) {
            hideLoader()
            if (error.response?.data?.errors) {
                const errorData = error.response?.data?.errors;
                const firstKey = Object.keys(errorData)[0];
                console.log(errorData)
                console.log(firstKey)
                console.log(errorData[firstKey])
                toast.error(errorData[firstKey][0] || 'Error saving Order: Something went wrong');
            } else {
                toast.error('Error saving Order: Something went wrong');
            }
        }
    };

    const [showModal, setShowModal] = useState(false);
    const [showSupplierModal, setshowSupplierModal] = useState(false);

    const closeModal = () => {
        setShowModal(false);
        setshowSupplierModal(false)
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === 'qty' && value && parseInt(productdata?.total_remaining_qty) < parseInt(value)) {
            // return
        }

        if (name === "product_id") {
            setInputValue(e.target?.pro_name);
            // if(rows.some(item => item.product_id == value)){
            //     return
            // }
            setFilteredProducts([]);
        }

        if (name === 'customer_id') {
            setSupplierValue(e.target?.pro_name);
            setSupplierId(e.target?.value);
            setFilteredSuppliers([])
            setformData({ ...formData, [name]: value })
        } else if (name === 'product_id') {
            var prodata = e.target?.prodata;
            console.log(e.target)
            setInputValue(e.target?.pro_name);
            setFilteredProducts([]);
            setformData({
                ...formData,
                [name]: value,
                // manufactured_date: prodata?.latest_manufacturing_date,
                // expiry_date: prodata?.latest_expiry_date,
                sales_price: formData?.purchase_type == "1" ? prodata?.avg_sales_price?.toFixed(3) : prodata?.box_sales_cost?.toFixed(3), //box_sales_cost
                purchase_price: prodata?.avg_purchase_price?.toFixed(3),
                box_sales_cost: prodata?.box_sales_cost?.toFixed(3),
                qty: 0
            })
        } else {
            setformData({ ...formData, [name]: value })
        }

        if (name == 'sales_price') {
            setformData({ ...formData, ["total_amount"]: formData.qty * value, [name]: value })
        } else if (name == "qty") {
            setformData({ ...formData, ["total_amount"]: (formData.sales_price || 0) * value, [name]: value })
        }
    };

    useEffect(() => {
        console.log(productdata);
        // setformData({
        //     ...formData,
        //     sales_price: productdata?.avg_sales_price?.toFixed(3),
        //     purchase_price: productdata?.avg_purchase_price?.toFixed(3),
        //     box_sales_cost: productdata?.box_sales_cost?.toFixed(3),
        //     qty: 0
        // })
    }, [productdata])

    const handlecancel = () => {
        setformData({
            invoice_no: '',
            invoice_date: '',
            ref_1: '',
            ref_2: '',
            purchase_unit: '1',
            tax_type: '',
            remark: '',
            supplier_invoice_no: '',
            supplier_invoice_date: '',
            product_id: "",
            product_name: "",
            supplier_id: '',
            purchase_price: '',
            qty: '',
            total_amount: '',
            sales_price: '',
            manufacturer_id: "",
            product_code: '',
            storage_type: '',
            box_sales_cost: '0',
            purchase_type: "1",
            approval_status:"",
            currency_type: " ",
            remarks: "",
            delivery_time:"",
            payment_terms:"",
            warranty:"",
            discount:"",
            tax_number:"",
            category_type:"",
            sales_contact:"",
            sales_person:""
            // lpo_no: "",
        })
        setInputValue('')
        setproductData()
        setsupplierData('')
        setSupplierValue('')

    }
    const [showCustomer, setShowCustomer] = useState(false);
    const fields = (
        <>
            {/* <div className='row'> */}
            {/* <div className='col-lg-4 col-12'> */}
            {/* <div className='card p-3' style={{ minHeight: '180px' }}>
                        {InputField('Invoice No', 'invoice_no', 'text', formData.invoice_no, handleChange, 'Enter Invoice no', 12)}
                        {InputField('Invoice Date', 'invoice_date', 'date', formData.invoice_date, handleChange, 'Enter Invoice date', 12)}
                        {InputField('Reference 1', 'ref_1', 'text', formData.ref_1, handleChange, 'Enter reference 1', 12)}
                        {InputField('Reference 2', 'ref_2', 'text', formData.ref_2, handleChange, 'Enter reference 2', 12)}
                        {SelectOption('Purchase Type', 'purchase_unit', formData.purchase_unit, handleChange, 'Select Purchase', [
                            {
                                title: "Cash",
                                id: "1",
                            },
                            {
                                title: "Credit",
                                id: "2"
                            },
                        ])}
                        {SelectOption('Tax Type', 'tax_type', formData.tax_type, handleChange, 'Select Tax', taxes)}
                    </div> */}
            {/* </div> */}
            {/* <div className='col-lg-4 col-12'>
                    <div className='card mb-0 p-3'> */}
         <div className='card p-2'>
            <div className='col-lg-10 col-12'>
                <div className='row justify-content-between'>
                    <div className={`form-group col-4 d-flex align-items-center  mb-2`}>
                        <label className="col-4 text-verysmall">Customer</label>
                        <div className="searchable-dd  d-flex w-100">
                            <input
                                type="text"
                                className="text-small w-100 mb-0"
                                value={SupplierValue}
                                onChange={(e) => handleSupplierChange(0, e.target.value)}
                                placeholder="Search Customer"
                                required
                            />
                            {SupplierValue && filteredSuppliers.length > 0 && (
                                <div className="custom-dropdown">  
                                    {filteredSuppliers.map((pro) => (
                                        <div
                                            key={pro.product_id}
                                            className="dropdown-item"
                                            onChange={(e) => handleChange({ target: { name: "customer_id", value: pro.customer_id, pro_name: pro.name } })}
                                            onClick={(e) => {
                                                handleChange({ target: { name: "customer_id", value: pro.customer_id, pro_name: pro.name, prodata: pro } });
                                                setsupplierData(supplier.find(item => item.customer_id == pro.customer_id))
                                                setPreviousDue(pro?.last_remaining)
                                            }}>
                                            {pro.name}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => setShowCustomer(true)}
                            style={{ fontSize: "9px" }}
                            className="btn btn-secondary font hover:bg-gray-600 mx-2 p-1 text-white transition">
                            Add
                        </button>
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Tax number', 'tax_number', 'number', formData.tax_number, handleChange, 'Enter Tax Number', 12)}
                    </div>
                    {/* {InputField('Address', 'ref_1', 'text', supplierdata?.address1 || '', () => { }, ' ', 4, null, undefined, undefined, true)}
                        {InputField('Contact no', 'ref_2', 'text', supplierdata?.phone || '', () => { }, '', 4, null, undefined, undefined, true)} */}
                    {/* <div className='d-flex mt-2 column-gap-4'><span className='text-small font-weight-2'>Balance</span><span className='text-small font-weight-2'>0.00</span></div> 
                    <div className={`col-lg-4 col-12`}>
                        {SelectOption('Purchase Type', 'purchase_type', formData.purchase_type, handleChange, 'Select Purchase', [
                            {
                                title: "Single",
                                id: "1",
                            },
                            {
                                title: "Box",
                                id: "2"
                            },
                        ])}
                    </div>

                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Total amount', 'total_amount', 'number', formData?.total_amount, handleChange, 'Enter Amount', 12)}
                    </div>
                    {InputField('L.P.O NO.', 'lpo_no', 'text', formData.lpo_no, handleChange, 'Enter L.P.O NO', 4)} */}
                </div>
                <div className='row '>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Finance code', 'finance_code', 'text', formData.finance_code, handleChange, 'Enter Finance Code', 12,null,undefined,undefined,true)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Category', 'category_type', 'text', formData.category_type, handleChange, 'Enter Category  type', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Payment terms', 'payment_terms', 'text', formData.payment_terms, handleChange, 'Enter Payment Terms', 12)}
                    </div>
                   
                </div >
                <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField(' Discount %', 'discount', 'number', formData.discount, handleChange, 'Enter discount %', 12, null, null, 99)}
                    </div>
                    
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Currency ', 'currency_type', 'text', formData.currency_type, handleChange, 'Enter  Currency', 12)}
                    </div>
                    <div className={`form-group col-4 mb-2 d-flex align-items-center`}>
                            {InputField('Quatation Expiry', 'expiry_date', 'date', formData.expiry_date, handleChange, 'Enter Rate', 12)}
                        </div>
                   
                </div>
                <div className='row'>
                    
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Request No', 'request_no', 'text', formData.request_no, handleChange, 'Enter Request Number', 12,null,undefined,undefined,true)}
                    </div>
               
                    <div className={`form-group col-4  d-flex align-items-center`}>
                    {SelectField(
                        'Approval Status',
                        'approval_status',
                        formData.approval_status,
                        handleChange,
                        [
                        { value: 0, label: 'Pending' },
                        // { value: 1, label: 'Approved' },
                        // { value: 2, label: 'Rejected' }
                        ],
                        12,
                        true
                    )}

                    </div>
                    <div className={`form-group col-4 mb-2 d-flex align-items-center`}>
                            {InputField('Sales Person', 'sales_person', 'text', formData.sales_person, handleChange, 'Enter Sales Person', 12)}
                        </div>
                       
                    </div>
                    <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Company Name', 'company_name', 'text', formData.company_name, handleChange, 'Enter comapany name', 12)}
                    </div>

                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Contact person ', 'contact_person', 'text', formData.contact_person, handleChange, 'Enter contact person', 12)}
                    </div>
                    <div className={`form-group col-4 mb-2 d-flex align-items-center`}>
                            {InputField('Sales Contact', 'sales_contact', 'text', formData.sales_contact, handleChange, 'Enter Sales Contact', 12)}
                        </div>
                     
                </div>
                    </div>
            </div>
            {/* </div> */}
            <div className='col-lg-10 col-12'>
                <div className='row'>
                    <div className={`form-group col-4 d-flex align-items-center`}>
                        <label className="col-4 text-verysmall">Product</label>
                        <div className="searchable-dd mb-2 w-100 d-flex" style={{ maxHeight: '1rem' }}>
                            <input
                                type="text"
                                className="text-small w-100"
                                value={inputValue}
                                onChange={(e) => handleProductChange(0, e.target.value)}
                                placeholder="Search Product"
                                required
                            />
                            {inputValue && filteredProducts.length > 0 && (
                                <div className="custom-dropdown">
                                    {filteredProducts.map((pro) => (
                                        <div
                                            key={pro.product_id}
                                            className="dropdown-item"
                                            onChange={(e) => handleChange({ target: { name: "product_id", value: pro.product_id, pro_name: pro.product_name, prodata: pro } })}
                                            onClick={(e) => {
                                                handleChange({ target: { name: "product_id", value: pro.product_id, pro_name: pro.product_name, prodata: pro } });
                                                console.log(products.find(item => item.product_id == pro.product_id))
                                                setproductData(products.find(item => item.product_id == pro.product_id))
                                            }}
                                        >
                                            {pro.product_name}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Item code', 'qty', 'text', productdata?.product_code || "", () => { }, ' ', 12, null, undefined, undefined, true)}
                    </div> */}
                         <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Product Desc', 'remarks', 'text', formData.remarks, handleChange, 'Enter Remarks', 12)}
                    </div>
              
                    <div className={`col-lg-4 col-12`}>
                        {SelectOption('Sales Type', 'purchase_type', formData.purchase_type, handleChange, 'Select Purchase', [
                            {
                                title: "Single",
                                id: "1",
                            },
                            {
                                title: "Box",
                                id: "2"
                            },
                        ])}
                    </div>
                </div>
                <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Quantity', 'qty', 'number', formData.qty, handleChange, 'Enter Quantity', 12, null, undefined, 100000000)}
                        {/* {InputField('Quantity', 'qty', 'number', formData.qty, handleChange, 'Enter Quantity', 12, null, undefined, productdata?.total_remaining_qty || 0)} */}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Sales Rate', 'sales_price', 'number', formData.sales_price, handleChange, 'Enter Rate', 12)}
                    </div>
           

                            <div className={`form-group col-4  d-flex align-items-center`}>
                    {InputField('Total amount', 'total_amount', 'number', formData?.total_amount, handleChange, 'Enter Amount', 12)}
                    </div>
                    
                </div>
                <div className='row'>
                    {/* <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Box Sales Rate', 'box_sales_cost', 'number', formData.box_sales_cost, handleChange, 'Enter Box Sales Rate', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Price', 'purchase_price', 'number', formData.purchase_price, handleChange, 'Enter Price', 12)}
                    </div> */}
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField(' Delivery', 'delivery_time', 'text', formData.delivery_time, handleChange, 'Enter Delivery Time', 12)}
                    </div>
                   
                </div>
                {/* <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Finance code', 'finance_code', 'number', formData.finance_code, handleChange, 'Enter Finance Code', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Category', 'category_type', 'text', formData.category_type, handleChange, 'Enter Category  type', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Tax number', 'tax_number', 'number', formData.tax_number, handleChange, 'Enter Tax Number', 12)}
                    </div>
                   
                </div>
                <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField(' Discount', 'discount', 'number', formData.discount, handleChange, 'Enter discount', 12)}
                    </div>
                   
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Currency type', 'currency_type', 'text', formData.currency_type, handleChange, 'Enter Currency Type', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Payment terms', 'payment_terms', 'text', formData.payment_terms, handleChange, 'Enter Payment Terms', 12)}
                    </div>
                   
                </div>
                <div className='row'>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField(' Delivery Time', 'delivery_time', 'number', formData.delivery_time, handleChange, 'Enter Delivery Time', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                        {InputField('Remarks', 'remarks', 'text', formData.remarks, handleChange, 'Enter Remarks', 12)}
                    </div>
                    <div className={`form-group col-4  d-flex align-items-center`}>
                    {SelectField(
                        'Approval Status',
                        'approval_status',
                        formData.approval_status,
                        handleChange,
                        [
                        { value: 0, label: 'Pending' },
                        { value: 1, label: 'Approved' },
                        { value: 2, label: 'Rejected' }
                        ],
                        12
                    )}

                    </div>
                    
                   
                </div> */}
            </div>

            <div className='col-lg-2 col-12 d-flex flex-column row-gap-2'>
                <button className="btn btn-primary text-small w-75" onClick={() => handleAddRow()}>Add Row</button>
                <button className="btn btn-secondary text-small w-75" onClick={() => handlecancel()}>Cancel</button>
            </div>


        </>
    )

    const getTotalOld = () => {
        var sub_total = rows.reduce((acc, item) => acc + (item.total_amount || 0), 0);
        var dis = ((rows.reduce((acc, item) => acc + (item.total_amount || 0), 0)) * (discount ? parseFloat(discount) : 0)) / 100;
        var varcount = ((rows.reduce((acc, item) => acc + (item.total_amount || 0), 0)) * (vat ? parseFloat(vat) : 0)) / 100;
        // var total = sub_total - (dis + varcount);
        var total = (sub_total - dis) + varcount;
        return total;
    }

    const getTotal = () => {
        var sub_total = rows.reduce((acc, item) => acc + (item.total_amount || 0), 0);
        var dis = (sub_total * (discount ? parseFloat(discount) : 0)) / 100;
        var varcount = (sub_total * (vat ? parseFloat(vat) : 0)) / 100;
        var freight = freightCharges ? parseFloat(freightCharges) : 0;
        var other = otherCharges ? parseFloat(otherCharges) : 0;

        var total = (sub_total + varcount + freight + other) - dis;
        var roundOff = Math.round(total) - total; // Calculates the rounding difference
        var grandTotal = total + roundOff; // Grand total after rounding
        var balance = (previousDue ? parseFloat(previousDue) : 0); // Balance = Previous Due + Grand Total
        if (formData.purchase_unit == "2") {
            balance = (previousDue ? parseFloat(previousDue) : 0) + grandTotal;
        }
        return { sub_total, total, roundOff, grandTotal, balance };
    };

    return (
        <div className="page-content">
            <div className="row">
                <div className='col-6 d-flex column-gap-3 align-items-center'>
                    <button className='btn py-1 btn-secondary text-small d-none' onClick={() => navigate(-1)}>Back</button>
                    <h3>{unqui}</h3>
                </div>
            </div>
            <NewCommonCardUi feilds={fields} />
            <div className="container-fluid mt-1 px-2 pb-4">
                <div className="row">
                    <div className="card col-12">
                        <div className="card-body">
                            <div className="d-flex justify-content-end">
                                {/* <button className="btn my-1 btn-primary py-1 btn-sm text-normal rounded-1"
                                        onClick={HandleSubmit}
                                        width={"20px"}>
                                        submit
                                    </button> */}
                            </div>
                            <div className="table-responsive" style={{ minHeight: "300px" }}>
                                <table
                                    id="example"
                                    className="table table-striped table-sm table-bordered"
                                    style={{ width: "100%", }}
                                >
                                    <thead>
                                        <tr>
                                            <th className='text-small'>S.No</th>
                                            <th className='text-small'>product Name</th>
                                            <th className='text-small'>Desc</th>
                                            <th className='text-small'>warehouse</th>
                                            <th className='text-small'>Qty</th>
                                            <th className='text-small'>sales rate</th>
                                            <th className='text-small'>total amount</th>
                                            <th className='text-small'>Delivery Time</th>
                                            <th className='text-small'>Purchase type</th>
                                            <th className='text-small'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                           
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td 
                                            title={row.product_name}>{row.product_name?.substring(0,25)}</td>
                                                <td>{row.item_code}</td>
                                                <td>{selectedWarehouse?.title}</td>
                                                <td>{row.qty}</td>
                                                <td>{row.sales_price}</td>
                                                <td>{row.total_amount}</td>
                                                <td>{row.delivery_time}</td>
                                                <td>{row.purchase_type == "1" ? "Single" : "Box"}</td>
                                                <td>
                                                    <img src="/assets/images/icons/delete.png"
                                                        className='m-1'
                                                        onClick={() => handleRemoveRow(index)}
                                                        width={"20px"} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className='float-end'>
                            <tr>
                            <td colSpan="4" ><strong>Total</strong></td>
                            <td> :</td>
                            <td ><strong>{rows.reduce((acc, row) => acc + Number(row.total_amount), 0).toFixed(3)}</strong></td>
                            {/* <td ><strong>{(rows.reduce((acc, row) => acc + Number(row.total_amount), 0) * (1 - Number(formData.discount || 0) / 100)).toFixed(3)}</strong></td> */}
                            <td colSpan="4">
                            </td>
                            </tr>
                            <tr>
                                <td colSpan="4"><strong>Discount ({formData.discount || 0}%)</strong></td>
                                <td>:</td>
                                <td>
                                    <strong>
                                    {(rows.reduce((acc, row) => acc + Number(row.total_amount), 0) * (Number(formData.discount || 0) / 100)).toFixed(3)}
                                    </strong>
                                </td>
                                <td colSpan="4"></td>
                                </tr>
                            <tr>
                            <td colSpan="4" ><strong> Grand Total</strong></td>
                            <td> :</td>
                            {/* <td ><strong>{rows.reduce((acc, row) => acc + Number(row.total_amount), 0).toFixed(3)}</strong></td> */}
                            <td ><strong>{(rows.reduce((acc, row) => acc + Number(row.total_amount), 0) * (1 - Number(formData.discount || 0) / 100)).toFixed(3)}</strong></td>
                            <td colSpan="4">
                            </td>
                            </tr>

                            </div>
                        </div>
                    </div>
                    {/* <div className='col-2 p-0 ps-1' style={{ height: 'fit-content' }}>
                        <div className='card py-2 border-black p-1' style={{ height: 'fit-content' }}>
                            {InputField('Sub Total', 'sub_total', 'text', getTotal().sub_total, () => { }, "", 12, null, null, undefined, true)}

                            <div className={`form-group mb-1 d-flex align-items-end col-${12}`}>
                                <div className="col-4">
                                    <label className="col-12 text-verysmall">{"Discount"}</label>
                                    <div className="col-12">
                                        <input
                                            type={"text"}
                                            value={discount}
                                            onChange={(e) => { setDiscount(e.target.value) }}
                                            className="text-verysmall col-9"
                                            style={{ height: '1.5rem' }}
                                            placeholder='00.0'
                                        />
                                        <label className="col-3 text-verysmall">%</label>
                                    </div>
                                </div>

                                <div className="col-8">
                                    <input
                                        className="w-100 text-verysmall"
                                        style={{ height: '1.5rem' }}
                                        value={
                                            ((rows.reduce((acc, item) => acc + (item.total_amount || 0), 0)) * (discount ? parseFloat(discount) : 0)) / 100
                                        }
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            <div className={`form-group mb-1 d-flex align-items-end col-${12}`}>
                                <div className="col-4">
                                    <label className="col-12 text-verysmall">{"VAT"}</label>
                                    <div className="col-12">
                                        <input
                                            type={"text"}
                                            value={vat}
                                            onChange={(e) => { setVat(e.target.value) }}
                                            className="text-verysmall col-9"
                                            style={{ height: '1.5rem' }}
                                            placeholder='00.0'
                                        />
                                        <label className="col-3 text-verysmall">%</label>
                                    </div>
                                </div>
                                <div className="col-8">
                                    <input
                                        className="w-100 text-verysmall"
                                        style={{ height: '1.5rem' }}
                                        disabled={true}
                                        value={
                                            ((rows.reduce((acc, item) => acc + (item.total_amount || 0), 0)) * (vat ? parseFloat(vat) : 0)) / 100
                                        }
                                    />
                                </div>
                            </div>

                            {InputField('Freight Charges  ', 'freight_charges ', 'number', freightCharges, (e) => { setFreightCharges(e.target.value) },)}
                            {InputField('Other Charges  ', 'other_charges', 'number', otherCharges, (e) => { setOtherCharges(e.target.value) },)}
                            {InputField('Previous Due  ', 'Vat', 'text', previousDue, () => { }, "", 12, 0, "", undefined, true)}
                            {InputField('Total', 'Vat', 'text', getTotal().total.toFixed(3), () => { }, "", 12, 0, "", undefined, true)}
                            {InputField('Round off', 'round_off', 'text', getTotal().roundOff.toFixed(3), () => { }, "", 12, 0, "", undefined, true)}
                            {InputField('Grand Total', 'Vat', 'text', getTotal().grandTotal, () => { }, "", 12, 0, "", undefined, true)}
                            {InputField('Balance', 'Vat', 'text', getTotal().balance, () => { }, "", 12, 0, "", undefined, true)}
                        </div>
                    </div> */}
                </div>
            </div>

            {showModal && (
                <ProductForm
                    selectedProduct={selectedProduct}
                    closeModal={closeModal}
                    refreshList={fetchProducts}
                />
            )}
            {showSupplierModal && (
                <SupplierForm
                    // selectedSupplier={selectedSupplier}
                    onClose={() => closeModal()}
                    fetchSuppliers={fetchSuppliers}
                />
            )}
            <div className='fixed-bottom bg-white d-flex justify-content-center py-2 column-gap-3' style={{ height: '50px' }}>
                {/* <button className='btn-secondary btn py-0 text-small'>Cancel</button> */}
                <button className='btn-primary btn py-0 text-small' onClick={() => HandleSubmit()}>Submit</button>
            </div>

            <CustomerAddModal
                showCustomer={showCustomer}
                setShowCustomer={setShowCustomer}
                onReqCustomer={fetchSuppliers} />
        </div>
        // </div>
    );
};

export default AddQuotation;
